module.exports = __webpack_public_path__ + "static/media/mobiru-gadget-logo.9be93727.png";